// Helper function to normalize a path by removing trailing slashes
const normalizePath = (path: string): string => {
  return path.replace(/\/+$/, '');
};

// Helper function to check if a path is public
export const isPublicRoute = (publicRoutes: string[], pathname: string): boolean => {
  const normalizedPath = normalizePath(pathname);
  return publicRoutes.some((route) => {
    const normalizedRoute = normalizePath(route);
    // Check for exact match or if the path starts with the route followed by a slash
    return normalizedPath === normalizedRoute || normalizedPath.startsWith(`${normalizedRoute}/`);
  });
};

// Helper function to check if a path is guest-only
export const isGuestOnlyRoute = (guestOnlyRoutes: string[], pathname: string): boolean => {
  const normalizedPath = normalizePath(pathname);
  return guestOnlyRoutes.some((route) => {
    const normalizedRoute = normalizePath(route);
    // Check for exact match or if the path starts with the route followed by a slash
    return normalizedPath === normalizedRoute || normalizedPath.startsWith(`${normalizedRoute}/`);
  });
};
